import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Avatar,
} from "antd";
import {State, City } from "country-state-city";
import { firestore, storage } from "../../config/firebase";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import CircularProgress from "@mui/material/CircularProgress";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
  getDoc,
} from "firebase/firestore";

import {
  EditOutlined,
  UserOutlined,
} from "@ant-design/icons";
import Select from "react-select";
import { emailRegex, getDuration, regexPattern } from "../../utils/constants";
import moment from "moment";

const CounsellorStats = lazy(() => import("./counsellorStats"));

const CounsellorProfile = ({
  chatLogs,
  logs,
  reviews,
  voiceLogs,
  videoLogs,
}) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    state: "",
    city: "",
    dateJoined: "",
  });
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [stateCode, setStateCode] = useState("");
  const [errors, setErrors] = useState({});
  const [logsCount, setLogsCount] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [avg, setAvg] = useState("");

  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const selectedUser = location.state?.selectedUser || null;

  const handleValidation = () => {
    const newErrors = {};
    if (!formData.firstName || formData.firstName == "")
      newErrors.fName = "First name is required";
    else if (formData.firstName.length < 3 || formData.firstName.length > 50)
      newErrors.fName = "First name must be 3 to 50 characters long";

    if (!formData.lastName || formData.lastName == "")
      newErrors.lName = "Last name is required";
    else if (formData.lastName.length < 3 || formData.lastName.length > 50)
      newErrors.lName = "Last name must be 3 to 50 characters long";

    if (!formData.email || formData.email == "")
      newErrors.email = "Email is required";
    if (!formData.phone || formData.phone == "")
      newErrors.phone = "Phone number is required";
    else if (!emailRegex.test(formData.email))
      newErrors.email = "Enter a valid email address";

    if (!formData.city || formData.city == "") newErrors.city = "Select city";
    if (!formData.state || formData.state == "")
      newErrors.state = "Select state";
    if (!formData.dateJoined) newErrors.dateJoined = "Date is required";
    setErrors(newErrors);

    return Object.keys(newErrors).length == 0;
  };


  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timeoutId = setTimeout(() => {
        setErrors({});
      }, 5000);

      // Clean up the timeout on component unmount
      return () => clearTimeout(timeoutId);
    }
  }, [errors]);


  const handleOnChange = (e) => {
    if (regexPattern.test(e.target.value)) {
      if (e.target.name == "firstName") {
        setFormData({ ...formData, firstName: e.target.value });
      } else setFormData({ ...formData, lastName: e.target.value });
    }
  };

  useEffect(() => {
    if (!stateList.length) {
      setStateList([
        ...State.getStatesOfCountry("IN").map((el, index) => {
          return { value: el.isoCode, label: el.name };
        }),
      ]);
    }
  }, []);

  useEffect(() => {
    if (stateCode) {
      setCityList([
        ...City.getCitiesOfState("IN", stateCode).map((el) => {
          return { label: el.name };
        }),
      ]);
    }
  }, [stateCode]);
  
  const handleUpdateCounsellor = async () => {
    let validation = handleValidation();
    let err = {};
    if (validation) {
      try {
        const querySnapshot = await getDocs(
          collection(firestore, "councellors")
        );

        let result = querySnapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((res) => {
            if (res.email == formData.email && res.uuid != formData.uuid) {
              return res;
            }
          });
        if (result.length) {
          err.email = "Email already exist";
          setErrors(err);
          return;
        }
        const updatedData = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          city: formData.city,
          state: formData.state,
        };

        await updateDoc(
          doc(firestore, "councellors", selectedUser.id),
          updatedData
        );
        navigate("/counsellorlist");
      } catch (error) {
        alert("Cannot perform this action.Try again");
        console.error("Error updating counsellor:", error);
      }
    }
  };

  const handleFileInputChange = async (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      let oldImageUrl = null;
      const adminDocRef = doc(firestore, "councellors", selectedUser.id);
      const adminDocSnapshot = await getDoc(adminDocRef);

      if (adminDocSnapshot.exists()) {
        const data = adminDocSnapshot.data();
        oldImageUrl = data.image || null;
      }

      if (oldImageUrl) {
        const oldImageRef = ref(storage, oldImageUrl);
        try {
          await deleteObject(oldImageRef);
        } catch (deleteError) {
          console.error("Error deleting old image:", deleteError);
        }
      }

      const uniqueFilename = `${Date.now()}-${uuidv4()}`;
      console.log("uniqueFilename------",uniqueFilename)
      const storageRef = ref(storage, `avatars/${uniqueFilename}`);
      uploadBytes(storageRef, selectedFile)
        .then((snapshot) => getDownloadURL(snapshot.ref))
        .then((downloadURL) => {
          setSelectedImage(downloadURL);
          return updateDoc(adminDocRef, {
            image: downloadURL,
          });
        })
        .then(() => {
          console.log("Image URL updated in Firestore");
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const handleEditIconClick = (e) => {
    e.stopPropagation();
    fileInputRef.current.click();
  };

  useEffect(() => {
    setFormData(selectedUser);
    setSelectedImage(selectedUser.image);
  }, []);

 
  useEffect(() => {
    setLogsCount({
      logs: logs.length,
      voiceLogs: voiceLogs.length,
      videoLogs: videoLogs.length,
      chatLogs: chatLogs.length,
    });
    let startTime = 0;
    let endTime = 0;
    let totalAvg = 0;
    let rating = 0;
    if (reviews.length) {
      reviews.forEach((el) => {
        rating += el.star;
      });
      rating = rating / reviews.length;
    }
    logs?.forEach((el) => {
      startTime += el.start_time;
      endTime += el.end_time;
    });
    totalAvg = endTime - startTime;
    setAvg({
      totalAvg: getDuration(Math.floor(totalAvg / logs.length) || 0),
      avgRating: rating ?? 5,
    });
  }, [logs]);

  return (
    <div
      style={{
        flexDirection: "row",
        display: "flex",
        justifyContent: "flex-start",
      }}
    >
      <div className="form-container-main" style={{ width: "40%" }}>
        <div
          style={{
            position: "relative",
          }}
        >
          <Avatar
            size={64}
            icon={<UserOutlined />}
            style={{ position: "relative" }}
            onClick={handleEditIconClick}
            src={selectedImage}
            alt="Selected"
          ></Avatar>

          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={(e) => handleFileInputChange(e)}
          />

          <EditOutlined
            style={{
              position: "absolute",
              bottom: 10,
              zIndex: 4,
            }}
            onClick={handleEditIconClick}
          />
        </div>

        <div className="form" style={{ boxShadow: "none" }}>
          <label>
            First Name:
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleOnChange}
            />
            <span className="errors">{errors.fName ?? " "}</span>
          </label>
          <label>
            Last Name:
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleOnChange}
            />
            <span className="errors">{errors.lName ?? " "}</span>
          </label>
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
            />
            <span className="errors">{errors.email ?? " "}</span>
          </label>
          <label>
            Phone:
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              // onChange={handlePhoneNumberChange}
              disabled
            />
            <span className="errors">{errors.phone ?? " "}</span>
          </label>
          <label>
            State:
            <Select
              onChange={async (a) => {
                setStateCode(a.value);
                setFormData({ ...formData, state: a.label });
              }}
              options={stateList}
              placeholder={formData.state}
            />
            <span className="errors">{errors.state ?? " "}</span>
          </label>

          <label>
            City:
            <Select
              defaultValue={formData.city}
              onChange={async (a) => {
                setFormData({ ...formData, city: a.label });
              }}
              options={cityList}
              placeholder={formData.city}
            />
            <span className="errors">{errors.city ?? " "}</span>
          </label>

          <label>
            Date Joined:
            <input
              type="date"
              name="dateJoined"
              value={moment(formData.dateJoined).format('yyy-MM-DD')}
              // onChange={handleChange}
              disabled
            />
            <span className="errors">{errors.dateJoined ?? " "}</span>
          </label>
          <button
            type="submit"
            onClick={() => handleUpdateCounsellor()}
            disabled={selectedUser == formData}
          >
            Update
          </button>
        </div>
      </div>
      {logs && avg && logsCount ? (
        <Suspense fallback={<CircularProgress />}>
          <CounsellorStats logsCount={logsCount} avg={avg} logs={logs} />
        </Suspense>
      ) : (
        <CircularProgress />
      )}
    </div>
  );
};

export default CounsellorProfile;
